<template>
  <div class="taskProgress">
    <div class="content">
      <div class="itemLi" v-for="(item,index) in dataList" :key="index" style="padding:10px;">
        <nut-row :gutter="10">
          <nut-col :span="18">设备ID: {{item.clNo}}</nut-col>
          <nut-col :span="6">
            <van-button type="danger" plain size="mini" @click="deleteBtn(item,'deleteSingle')">删除</van-button>
          </nut-col>
        </nut-row>
        <nut-row :gutter="10">
          <nut-col>任务名称: {{item.taskName}}</nut-col>
        </nut-row>
        <nut-row :gutter="10">
          <nut-col :span="12">任务大小: {{item.totalFileNum}}</nut-col>
          <nut-col :span="12">速度(kb/s): {{item.downKb}}</nut-col>
        </nut-row>
        <nut-row :gutter="10">
          <nut-col :span="12">下载进度: {{item.percent}}</nut-col>
          <nut-col :span="12">下载状态: <span :class="item.strColor">{{item.stateCh}}</span></nut-col>
        </nut-row>
      </div>
      <div v-if="dataList.length === 0" class="empty">
        暂无信息
      </div>
    </div>
    <div class="btns">
      <div style="">
        <van-button color="#409eff" size="small" @click="refresh">刷新</van-button>
        <span style="display: inline-block;width: 10px"></span>
        <van-button color="#409eff" size="small" @click="deleteBtn('','deleteAll')">清除所有</van-button>
        <span style="display: inline-block;width: 10px"></span>
        <van-button color="#409eff" size="small" @click="deleteBtn('','deleteFinish')">清除已完成</van-button>
      </div>
    </div>
  </div>
</template>

<script>
  import qs from 'qs'
  import { Toast, Dialog } from 'vant'

  export default {
    inject: ['reload'],
    name: 'taskProgress.vue',
    data() {
      return {
        dataList: [],
        timer: 0,
      }
    },
    mounted() {
      this.getProgressData()
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.getProgressData()
      }, 3000)
    },
    methods: {
      getProgressData() {
        this.$ajax('/etv/selectPageEqTaskProgress.json').then(res => {
          let arr = res.data.data.psersonList
          // 1：下载成功；2：等待下载；其他：下载中
          arr.forEach(res => {
            if (res.state == 1) {
              res.stateCh = '下载成功'
              res.strColor = 'strGreen'
           } else if (res.state == 2) {
              res.stateCh = '等待下载'
              res.strColor = 'strGray'
            } else {
              res.stateCh = '下载中'
              res.strColor = 'strGray'
            }
          })
          this.dataList = arr
        })
      },
      deleteBtn(r1, r2) {
        let postData = {
          type: r2,
        }
        let msg = ''
        if (r2 == 'deleteSingle') {
          postData.id = r1.id
          msg = '是否确定删除？'
        } else if (r2 == 'deleteAll') {
          msg = '是否确定删除所有？'
        } else if (r2 == 'deleteFinish') {
          msg = '是否确定删除选中？'
        }

        if(this.dataList.length == 0){
          Toast('没有可清除的数据！')
        }else{
          Dialog.confirm({
            title: '删除'
            , message: msg,
          }).then(() => {
            this.$ajax.post('/etv/deleteEqTaskProgressById.json', qs.stringify(postData)).then(res => {
              Toast(res.data.msg)
              this.getProgressData()
            })
          })
        }
      },
      refresh(){
        this.dataList = []
        this.getProgressData();
      }
    },
  }
</script>

<style lang="scss">
  .taskProgress {
    height: calc(100% - 0px);
    .btns {
      display: flex;
      height: 40px;
      justify-content: space-between;
      align-items: center;
      padding: 0 15px;
    }
    .content {
      height: calc(100% - 40px);
      overflow-y: auto;
      /*background: #f1f1f1;*/
      padding: 0 10px;
      .empty {
        height: 100px;
        width: 100%;
        text-align: center;
        line-height: 100px;
        color: #8c8c8c;
      }
      .itemLi {
        margin-top: 2px;
        background: #fff;
        font-size: 14px;

        .nut-row {
          margin: 4px 0;

          .nut-col {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            .strGreen {
              color: #2FC25B;
            }

            .strGray {
              color: #808080;
            }

            .strRed {
              color: red;
            }
          }
        }
      }
    }
  }
</style>
